import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import JournalModal from './journal';
import LoginModal from './login';
import ProfileModal from './profile';
import SignupModal from './signup';
import SMSModal from './sms';
import VIPUnsubscribe from './vip-unsubscribe';
import _ from 'underscore';
import dialogPolyfill from 'dialog-polyfill';

class Component extends BaseComponent {
    constructor() {
        super();
        this.dialog;
    }

    componentDidMount() {
        const that = this;

        if (typeof dialogPolyfill != 'undefined') {
            dialogPolyfill.registerDialog(this.dialog);
        }

        this.dialog.addEventListener('keydown', (e) => {
            if (e.keyCode == 27) {
                e.preventDefault();
                that.close();
            }
        });

        this.dialog.addEventListener('click', (e) => {
            if (e.target.tagName == 'DIALOG') {
                that.close();
            }
        });

        if (_.contains(['journal', 'login', 'login-signup', 'signup', 'sms'], this.props.route)) {
            this.dialog.showModal();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.route == '') {
            if (_.contains([
                'journal',
                'login',
                'login-signup',
                'profile',
                'signup',
                'sms',
                'vip-unsubscribe',
            ], this.props.route)) {
                this.dialog.close();
            }
        }

        if (nextProps.route != this.props.route) {
            return true;
        }

        return false;
    }

    render() {
        return (
            <modal>
                <dialog ref={el => this.dialog = el}>
                    {this.renderChild()}
                </dialog>
            </modal>
        );
    }

    renderChild = () => {
        if (this.props.route) {
            let ChildModal = null;

            if (this.props.route == 'journal') {
                ChildModal = JournalModal;
            } else if (this.props.route == 'login' || this.props.route == 'login-signup') {
                ChildModal = LoginModal;
            } else if (this.props.route == 'profile') {
                ChildModal = ProfileModal;
            } else if (this.props.route == 'signup') {
                ChildModal = SignupModal;
            } else if (this.props.route == 'sms') {
                ChildModal = SMSModal;
            } else if (this.props.route == 'vip-unsubscribe') {
                ChildModal = VIPUnsubscribe;
            }

            if (ChildModal) {
                if (this.dialog && !this.dialog.open) {
                    this.dialog.showModal();
                }

                return (<ChildModal close={this.close} />);
            }
        }

        return null;
    }

    close = () => {
        if (this.props.route == 'sms') {
            this.props.updateProduct({
                pending: false,
            });
        }

        this.props.trackEvent([
            'Site Interaction',
            'Close',
            `${this.props.route.charAt(0).toUpperCase()}${this.props.route.slice(1)}`,
        ]);

        this.props.routeTo('');
    }
}

const mapStateToProps = (state) => ({
    route: state.route,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (route) => dispatch({ type: 'route:to', payload: route }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    updateProduct: (payload) => dispatch({ type: 'product:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);